import React, { use, useRef, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useParams, useNavigate } from "react-router-dom";
import '../../../assets/css/style.css';
import '../../../assets/css/bootstrap.css';
import { MdDelete } from "react-icons/md";
import MyProfileImage from './default.webp';
import { LoginContext } from '../../../context/LoginContext';
import AddPhotos from "./add-image.jpg"


const ProfilePage = () => {
  const navigate = useNavigate();

  const [ismypro, setisMyPro] = useState(false);
  const [users, setUsers] = useState({});
  const [message, setMessage] = useState(null);
  // const [uploadError, setUploadError] = useState(null);
  const [isUpload, setIsUpload] = useState(true);
  const fileInputRef = useRef(null);

  const { userData, userId, isLoggedIn, setUserdata } = useContext(LoginContext);
  const param = useParams();

  const [file, setFile] = useState(null);



  const handleImgDelete = (image, src) => {

    const payload = new FormData();
    payload.append("id", userId);
    payload.append("looking", userData.looking_for);
    payload.append("gender", userData.gender);
    payload.append("status", userData.status);
    payload.append("email", userData.email);
    payload.append("img", image);
    payload.append("src", src);

    axios.post(`${process.env.REACT_APP_API_BASE_URL}Register_controller/deleteimage`, payload)
      .then(response => {
        if (response.data.response == "success") {
          fetchProfileImages();
        }
      })
      .catch(error => {
        console.error("There was an error fetching users!", error);
      });



  };

  const handleSetProfile = (image) => {
    console.log("Change Image - ", image);

    const payload = new FormData();
    payload.append("id", userId);
    payload.append("looking", userData.looking_for);
    payload.append("gender", userData.gender);
    payload.append("status", userData.status);
    payload.append("email", userData.email);
    payload.append("img", image);

    axios.post(`${process.env.REACT_APP_API_BASE_URL}Register_controller/setprofileimage`, payload)
      .then(response => {
        if (response.data.response == "success") {
          fetchProfileImages();
        }
      })
      .catch(error => {
        console.error("There was an error fetching users!", error);
      });




  };

  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
      setFile('');
    }
  };

  const fetchProfileImages = () => {

    const payload = new FormData();
    payload.append("id", userId);
    payload.append("looking", userData.looking_for);
    payload.append("gender", userData.gender);
    payload.append("status", userData.status);
    payload.append("email", userData.email);
    payload.append("find_id", param.id);
    payload.append("limit", 30);

    if (param.id === userId) setisMyPro(true);
    else setisMyPro(false);

    axios.post(`${process.env.REACT_APP_API_BASE_URL}mycon/fetchPhoto`, payload)
      .then(response => {
        if (response.data.response == "success") {
          setMessage((response.data.photos.image1) ? ('') : ("Please Set atleast one Profile Photo"));
          setUsers(response.data.photos);
          setUserdata(prev => ({ ...prev, pp: response.data.photos.image1 }));
        }
        // else {
        //   setMessage(response.data.message);
        // }
      })
      .catch(error => {
        console.error("There was an error fetching users!", error);
      });
  }

const allowedTypes = ['image/jpeg', 'image/gif', 'image/png'];
  const handleFileChange = (e) => {
    if (e.target.files) {
      const file = e.target.files[0];
      if (!file) return;

      if (!allowedTypes.includes(file.type)) {
        alert('Only JPG, PNG and GIF images are allowed.');
        e.target.value = ''; // reset input
        return;
      }

      setFile(e.target.files[0]);
      setIsUpload(false);
    }
  };


  const handleUpload = async (e) => {
    e.preventDefault();

    setIsUpload(true);

    /////formdata Image 
    const payload = new FormData();
    payload.append("id", userId);
    payload.append("img", file);
    payload.append("looking", userData.looking_for);
    payload.append("gender", userData.gender);
    payload.append("status", userData.status);
    payload.append("email", userData.email);
    payload.append("find_id", param.id);

    if (file) {
      axios.post(`${process.env.REACT_APP_API_BASE_URL}Register_controller/uploadImage`, payload,
        { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          if (response.data.response == "success") {
            fetchProfileImages();
            resetFileInput();
            setMessage((response.data.message) ? (response.data.message) : ("Please Set atleast one Profile Photo"));
          } else {
            setMessage(response.data.message);
          }
          setIsUpload(true);
        })
        .catch(error => {
          console.error("There was an error fetching users!", error);
        });
    }


  };


  useEffect(() => {

    if (!isLoggedIn) {
      navigate("/login");
    }

    fetchProfileImages();

  }, [param.id]);




  return (

    <>
      <section>
        <style>
          {`

.myshadow{
box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}



       .menu-pop-soci ul li link i {
            width: 38px;
    height: 38px;
    background: rgb(247, 247, 247);
    text-align: center;
    display: inline-block;
    border-radius: 5px;
    color: rgb(51, 51, 51);
    font-size: 18px;
    padding: 11px 8px;
    transition: all 0.5s ease;
}
         .member-info h5, .member-id{
            color: white !important;
            text-align: center;
    }
      .detail-label{
            color: white !important;
      }
      .detail-value{
            color: white !important;
      }
        .recently-joined-container {
          padding: 60px 20px;
          background: #fff;
        }
          .swiper-container {
          padding: 0 40px;
          position: relative;
          margin-bottom: 30px;
        }
        .member-card {
          width: 100%;
          max-width: 100%;
          margin: 0 auto;
          background: white;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease;
        }
        .member-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
        }
        .member-image {
          width: 100%;
          height: 300px;
          object-fit: cover;
          display: block;
        }
        .member-info {
          background: #E53D5C;
          color: white;
          padding: 15px;
        }
        .member-id-gender {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          justify-content: center;
        }
        .gender-badge {
          background: white;
          color: #E53D5C;
          border-radius: 3px;
          padding: 2px 5px;
          font-weight: bold;
          margin-right: 8px;
        }
        .member-id {
          font-weight: bold;
          font-size: 14px;
        }
        .member-details {
          font-size: 13px;
        }
        .detail-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 5px;
          padding-bottom: 5px;
          border-bottom: 1px solid rgba(255,255,255,0.1);
        }
        .detail-row:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }
        .detail-label {
          font-weight: 500;
        }
        .detail-value {
          text-align: right;
        }.swiper-button-next, .swiper-button-prev {
          color: #E53D5C;
          width: 40px;
          height: 40px;
          background: white;
          border-radius: 50%;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
        }
        .swiper-button-next:hover, .swiper-button-prev:hover {
          background: #E53D5C;
          color: white;
        }
        .swiper-button-next:after, .swiper-button-prev:after {
          font-size: 18px;
          font-weight: bold;
        }
        .swiper-pagination-bullet {
          background: #ccc;
          opacity: 1;
          width: 12px;
          height: 12px;
        }
        .swiper-pagination-bullet-active {
          background: #E53D5C;
        }
          .menu-pop-soci ul li  i {
    width: 38px;
    height: 38px;
    background: rgb(247, 247, 247);
    text-align: center;
    display: inline-block;
    border-radius: 5px;
    color: rgb(51, 51, 51);
    font-size: 18px;
    padding: 11px 8px;
    transition: all 0.5s ease;
}
        @media (max-width: 768px) {
          .swiper-container {
            padding: 0 20px;
          }
          .swiper-button-next, .swiper-button-prev {
            display: none;
          }
        }
        @media (max-width: 480px) {
          .recently-joined-container {
            padding: 40px 15px;
          }
          .member-details {
            font-size: 12px;
          }}


          .input-parent{
          border:1px solid #dc3545;
          border-radius:1rem;
          max-width:300px;
          overflow:hidden;
          }
          
          
          `}
        </style>
        <div class="profi-ban my-5">
          <div class="container">
            <div class="row">
              <div class="profile col-lg-4 col-md-12 col-xl-4">
                <div class="pg-pro-big-im">
                  <div class="s1">
                    <img src={(users.image1) ? process.env.REACT_APP_API_BASE_URL + users.image1 : MyProfileImage} loading="lazy" class="pro" alt="" />
                  </div>
                  {(ismypro) &&
                    <Link to={`/view-profile/${userId}`} className="btn rounded-0 btn-lg text-white d-block py-3" style={{ fontSize: "18px", background: "#E53D5C" }}><b>My Profile</b> </Link>}

                </div>
              </div>
              <div class="col-lg-8 col-md-12 col-xl-8">
                <div class="lhs">
                  <div id='form' class="pro-pg-intro">
                    <h1 style={{ textTransform: "capitalize" }}>{(users.name) ?? "Hi Guest"}</h1>
                    <div class="pro-info-status">
                      <h4 className='my-3' style={{ color: "red" }}>{message}</h4>

                      {((users.image1 == "") || (users.image2 == "") || (users.image3 == "") || (users.image4 == "") || (users.image5 == "") || (users.image6 == "")) &&
                        <form className='formData' onSubmit={handleUpload}>
                          <div className='input-parent mb-3'>
                            <input accept=".jpg,.jpeg,.gif,.png,image/jpeg,image/gif,image/png" ref={fileInputRef} type='file' onChange={handleFileChange} required />
                          </div>
                          <button className={'btn btn-danger mb-4'} type='submit' disabled={isUpload} > Upload</button>
                        </form>
                      }











                    </div>

                  </div>



                  <div class="pr-bio-c pr-bio-gal" id="gallery">
                    <h3 style={{ color: "#E53D5C" }}>Photo gallery</h3>
                    <div id="image-gallery">


                      {[2, 3, 4, 5, 6].map((index) => {
                        const imageKey = `image${index}`;
                        const imageUrl = users[imageKey];

                        if (imageUrl) {
                          return (
                            imageUrl && (
                              <div className="pro-gal-imag" key={index}>
                                <div className="img-wrapper position-relative">
                                  <a href="#">
                                    <img
                                      src={process.env.REACT_APP_API_BASE_URL + imageUrl}
                                      className="img-responsive rounded-0"
                                      alt=""
                                    />
                                  </a>

                                  <button
                                    className="btn btn-danger rounded-0 position-absolute"
                                    style={{ top: "10px", right: "10px", background: "red" }}
                                    onClick={() => handleImgDelete(index, imageUrl)}
                                  >
                                    <MdDelete className="text-white" />
                                  </button>

                                  <button
                                    type="button"
                                    className="btn btn-danger rounded-0 w-100 d-block"
                                    onClick={() => handleSetProfile(imageKey)}
                                  >
                                    Set as Profile Pic
                                  </button>
                                </div>
                              </div>
                            )
                          );
                        }
                        else {
                          return (<div className="pro-gal-imag  p-2 ">
                            <div className="img-wrapper position-relative myshadow border">
                              <a onClick={() => fileInputRef.current.click()} href="#form">
                                <img
                                  src={AddPhotos}
                                  className="img-responsive rounded-0"
                                  alt=""
                                />
                              </a>
                            </div>
                          </div>)
                        }


                      })}

                    </div>
                  </div>










                </div>
              </div>




            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProfilePage;
